import * as preact from "preact";

import readlangClient, { requestErrorMessage } from "readlangClient";

type Props = {
  appRouter: any;
};

type ProcessingResult = {
  invoiceId: number;
  success: boolean;
  email?: string;
  quadernoCustomerID?: string;
  error?: string;
};

type State = {
  invoiceIdsText: string;
  processing: boolean;
  results?: ProcessingResult[];
  summary?: {
    total: number;
    successful: number;
    failed: number;
  };
};

export default class AdminQuadernoInboxPage extends preact.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      invoiceIdsText: "",
      processing: false,
    };
  }

  processInvoiceIds = async () => {
    const invoiceIds = this.state.invoiceIdsText
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((line) => parseInt(line, 10))
      .filter((id) => !isNaN(id));

    if (invoiceIds.length === 0) {
      alert(
        "No valid invoice IDs found. Please enter numeric IDs, one per line."
      );
      return;
    }

    this.setState({ processing: true, results: undefined, summary: undefined });

    try {
      const response = await readlangClient.request(
        "POST",
        "/api/admin/quadernoInbox/process",
        { invoiceIds }
      );

      this.setState({
        processing: false,
        results: response.data.results,
        summary: response.data.summary,
      });
    } catch (error: any) {
      this.setState({ processing: false });
      if (!error?.jqXHR?.alreadyNotified) {
        alert("Error processing invoice IDs: " + requestErrorMessage(error));
      }
    }
  };

  render() {
    return (
      <div>
        <h1>
          <a href="/admin">Admin</a> - Quaderno Inbox
        </h1>

        <div>
          <h2>Process Quaderno Invoice IDs</h2>
          <p>
            Paste Quaderno invoice IDs below (one per line). Each invoice will
            be looked up in Quaderno, and a UserBillingInfo record will be
            created for the associated user with state "addressNeeded".
          </p>
          <textarea
            value={this.state.invoiceIdsText}
            onChange={(event) => {
              this.setState({ invoiceIdsText: event.currentTarget.value });
            }}
            placeholder="Enter invoice IDs, one per line..."
            style={{
              width: "100%",
              maxWidth: 400,
              height: 200,
              fontFamily: "monospace",
            }}
          />
          <br />
          <button
            onClick={this.processInvoiceIds}
            disabled={this.state.processing}
          >
            {this.state.processing ? "Processing..." : "Process"}
          </button>
        </div>

        {this.state.summary && (
          <div style={{ marginTop: 20 }}>
            <h2>Summary</h2>
            <ul>
              <li>Total processed: {this.state.summary.total}</li>
              <li>Successful: {this.state.summary.successful}</li>
              <li>Failed: {this.state.summary.failed}</li>
            </ul>
          </div>
        )}

        {this.state.results && (
          <div style={{ marginTop: 20 }}>
            <h2>Results</h2>
            <table>
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Status</th>
                  <th>Email</th>
                  <th>Quaderno Customer ID</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {this.state.results.map((result) => (
                  <tr key={result.invoiceId}>
                    <td>{result.invoiceId}</td>
                    <td style={{ color: result.success ? "green" : "red" }}>
                      {result.success ? "Success" : "Failed"}
                    </td>
                    <td>{result.email ?? "-"}</td>
                    <td>{result.quadernoCustomerID ?? "-"}</td>
                    <td>{result.error ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}
